import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Col, Row } from 'reactstrap'

const StiSymptoms = () => {
  return (
    <div id='website-responsive'>
        <div className='bg-img left-padding5rem1 right-padding5rem1 py-md-5 py-4' style={{ backgroundImage:"url('sti-testing/ULC-Testing-bg-v1.png')", height:'auto', width:'100%'}}>
            <Row className=''>
                <Col md='12' lg='7' className=''> 
                    <div className=''>
                        <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                            Symptoms of STIs
                        </div>
                        <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                    </div>

                    <div className='pt-2 pb-3'>
                        <div className='fs-ss-16 text-montserrat fw-600 text-ss-black'>
                        STIs can vary depending on the type of infection, and some conditions may not cause noticeable symptoms. However, common symptoms can include: 
                        </div>
                    </div>

                    <div className='py-2'>
                        <ol type='1' className='fs-ss-16 text-montserrat fw-600 text-ss-black ps-md-4' style={{ letterSpacing:'0.5px'}}>
                           <li className='pb-1'>Unusual discharge from the genitals (penis, vagina, or anus). </li> 
                           <li className='pb-1'>Pain or burning sensation during urination. </li> 
                           <li className='pb-1'>Genital itching or irritation.</li> 
                           <li className='pb-1'>Sores, blisters, or ulcers on or around the genitals, mouth, or rectum.</li> 
                           <li className='pb-1'>Pain or discomfort during sexual intercourse.</li> 
                           <li className='pb-1'>Swollen lymph nodes in the groin area.</li> 
                           <li className='pb-1'>Flu-like symptoms with fever, fatigue, and body aches. </li> 
                        </ol>
                    </div>

                    <div className=''>
                        <div className='fs-ss-16 text-montserrat fw-600 text-ss-black'>
                        It is important to note that symptoms alone may not be reliable indicators of an STI, as they can vary or be absent. Some STIs, such as chlamydia or gonorrhea, can be asymptomatic but pose serious health risks if not diagnosed and treated promptly. 
                        </div>
                    </div>

                    <div className='pt-4 flex-center1'>
                    <Link to='/sti-std-test-appointment'>
                     <Button className='btn-ss-secondary rounded30 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                        <text className='text-montserrat fw-600 fs-ss-16' style={{ padding:'10px 1  px',}}>
                           Get Tested Today
                        </text>
                    </Button>
                    </Link>
                    </div>
                </Col>
                <Col md='12' lg='5' className=''>
                    <div className='flex-center pt-5'>
                        <img src='sti-testing/STI-Testing-img1-v1.png' alt='Sti Symptoms' className='img-w5' height='auto' width='' />
                    </div>
                </Col>
            </Row>
        </div>
    </div>
  )
}

export default StiSymptoms